import { ScribblingPenIcon } from '@change/ds-icons';

import { Text } from '@change/ds-core-ui/next';

export const SignersText: React.FC<{ signersText: string }> = ({ signersText }) => {
	return (
		<div className="mr-4 flex items-center" data-testid="signers-text">
			<ScribblingPenIcon size={18} className="text-icon-weak mr-1" />
			<Text as="div" size="small" className="text-muted">
				{signersText}
			</Text>
		</div>
	);
};
